/* Centauri C16 — Buyer reviews. Mobile uses a 1.5-card scroll-snap reel with
   progressive controls; every review remains reachable without JavaScript. */
(function () {
  'use strict';

  var VERSION = '2026-08-25-mobile-peek-carousel';

  if (window.CentauriC16BuyerReviews && window.CentauriC16BuyerReviews.version === VERSION) {
    window.CentauriC16BuyerReviews.init();
    return;
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setupLineReveal(section) {
    if (!section || section.dataset.centauriLineRevealReady === 'true') return;
    section.dataset.centauriLineRevealReady = 'true';

    function reveal() {
      section.classList.add('is-line-revealed');
    }

    if (reduceMotion() || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        reveal();
        observer.disconnect();
        break;
      }
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0.16 });

    observer.observe(section);
    section.__centauriLineRevealObserver = observer;
  }

  function setButtonState(button, disabled) {
    if (!button) return;
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function setActiveReview(state, requestedPage) {
    var cards = state.track.querySelectorAll('.review-card');
    var count = cards.length;
    var mobile = isMobile();
    var page = clamp(typeof requestedPage === 'number' ? requestedPage : state.mobilePage || 0, 0, Math.max(count - 1, 0));

    state.mobilePage = page;
    for (var i = 0; i < count; i++) {
      var active = !mobile || i === page;
      cards[i].classList.toggle('is-active', active);
      cards[i].hidden = false;
      cards[i].setAttribute('aria-hidden', 'false');
    }

    if (!mobile || count <= 1) {
      state.nav.setAttribute('hidden', '');
    } else {
      state.nav.removeAttribute('hidden');
    }

    setButtonState(state.prev, !mobile || page === 0 || count <= 1);
    setButtonState(state.next, !mobile || page >= count - 1 || count <= 1);
    state.root.setAttribute('data-centauri-reviews-page', String(count ? page + 1 : 0));
    state.root.setAttribute('data-centauri-reviews-count', String(count));
  }

  function scrollToReview(state, requestedPage) {
    var cards = state.track.querySelectorAll('.review-card');
    var page = clamp(requestedPage, 0, Math.max(cards.length - 1, 0));
    setActiveReview(state, page);
    if (!isMobile() || !cards[page]) return;
    var target = cards[page].offsetLeft - (cards[0] ? cards[0].offsetLeft : 0);
    state.track.scrollTo({ left: target, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }

  function syncPageFromScroll(state) {
    if (!isMobile()) return;
    var cards = state.track.querySelectorAll('.review-card');
    var bestPage = 0;
    var bestDistance = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var target = cards[i].offsetLeft - (cards[0] ? cards[0].offsetLeft : 0);
      var distance = Math.abs(target - state.track.scrollLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestPage = i;
      }
    }
    if (bestPage !== state.mobilePage) setActiveReview(state, bestPage);
  }

  function setup(root) {
    var section = root && root.closest ? root.closest('.centauri-c16-buyer-reviews') : null;
    setupLineReveal(section);

    if (root.dataset.centauriReviewsReady === 'true') return;
    var track = root.querySelector('[data-centauri-reviews-track]');
    var nav = root.querySelector('[data-centauri-reviews-nav]');
    if (!track || !nav) return;

    var prev = nav.querySelector('[data-centauri-reviews-prev]');
    var next = nav.querySelector('[data-centauri-reviews-next]');
    var scheduled = false;
    var state = {
      root: root,
      track: track,
      nav: nav,
      prev: prev,
      next: next,
      mobilePage: 0,
      scrollFrame: 0,
      destroyed: false
    };

    function refresh() {
      if (state.destroyed) return;
      setActiveReview(state);
    }

    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (state.destroyed) return;
        refresh();
      });
    }

    state.onPrev = function () { scrollToReview(state, state.mobilePage - 1); };
    state.onNext = function () { scrollToReview(state, state.mobilePage + 1); };
    state.onScroll = function () {
      if (state.scrollFrame) return;
      state.scrollFrame = window.requestAnimationFrame(function () {
        state.scrollFrame = 0;
        if (!state.destroyed) syncPageFromScroll(state);
      });
    };
    if (prev) prev.addEventListener('click', state.onPrev);
    if (next) next.addEventListener('click', state.onNext);
    track.addEventListener('scroll', state.onScroll, { passive: true });

    // Store the rAF-throttled refresh on the root so the shared window
    // resize handler can reach every live reel, and teardown can prune it.
    root._centauriReviewsRefresh = scheduleRefresh;
    root._centauriReviewsState = state;

    refresh();
    // Re-evaluate once layout settles (late font swap / image reflow can
    // change card metrics and invalidate the overflow/nav decision).
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleRefresh);
    }

    root.dataset.centauriReviewsReady = 'true';
  }

  function destroy(root) {
    if (!root) return;

    var state = root._centauriReviewsState;
    if (state) {
      state.destroyed = true;
      if (state.prev) state.prev.removeEventListener('click', state.onPrev);
      if (state.next) state.next.removeEventListener('click', state.onNext);
      if (state.track) state.track.removeEventListener('scroll', state.onScroll);
      if (state.scrollFrame) window.cancelAnimationFrame(state.scrollFrame);
    }

    var cards = root.querySelectorAll ? root.querySelectorAll('.review-card') : [];
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-active');
      cards[i].hidden = false;
      cards[i].removeAttribute('aria-hidden');
    }

    var nav = root.querySelector ? root.querySelector('[data-centauri-reviews-nav]') : null;
    if (nav) nav.setAttribute('hidden', '');
    delete root._centauriReviewsRefresh;
    delete root._centauriReviewsState;
    root.removeAttribute('data-centauri-reviews-ready');
    root.removeAttribute('data-centauri-reviews-page');
    root.removeAttribute('data-centauri-reviews-count');
  }

  function refreshAll() {
    var roots = document.querySelectorAll('[data-centauri-reviews]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i]._centauriReviewsRefresh === 'function') {
        roots[i]._centauriReviewsRefresh();
      }
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-centauri-reviews]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  window.CentauriC16BuyerReviews = {
    version: VERSION,
    init: init,
    refreshAll: refreshAll,
    destroy: destroy
  };

  // Single window-level listeners bound exactly once at module scope, so
  // repeated shopify:section:load in the Theme Editor cannot accumulate
  // handlers bound to detached DOM.
  window.addEventListener('resize', refreshAll, { passive: true });
  window.addEventListener('load', refreshAll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the Theme Editor when a section/block is re-rendered.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    var target = event && event.target;
    if (!target) return;
    var roots = [];
    if (target.matches && target.matches('[data-centauri-reviews]')) roots.push(target);
    var found = target.querySelectorAll ? target.querySelectorAll('[data-centauri-reviews]') : [];
    for (var i = 0; i < found.length; i++) roots.push(found[i]);
    for (var i = 0; i < roots.length; i++) {
      destroy(roots[i]);
      var section = roots[i].closest ? roots[i].closest('.centauri-c16-buyer-reviews') : null;
      if (section && section.__centauriLineRevealObserver) {
        section.__centauriLineRevealObserver.disconnect();
        delete section.__centauriLineRevealObserver;
      }
    }
  });
  document.addEventListener('shopify:block:select', init);
})();
